import React from 'react';
import Loader from '../components/Loader';
import HeadPage from '../components/HeadPage';
import PropTypes from 'prop-types';

const SimplePageLayout = (props) => {
  const {
    pageTitle,
    pageDescription,
    hasBackButton,
    titleBgColor,
    loading,
    children,
  } = props;

  if (loading) {
    return <Loader />;
  }
  
  return (
    <>
      <HeadPage
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        hasBackButton={hasBackButton}
        titleBgColor={titleBgColor}
      />
      {children}
    </>
  );
};

SimplePageLayout.propTypes = {
  pageTitle: PropTypes.string,
  pageDescription: PropTypes.string,
  hasBackButton: PropTypes.bool,
  titleBgColor: PropTypes.string,
  activeNavigationTab: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.array.isRequired
};

SimplePageLayout.defaultProps = {
  hasBackButton: true,
  loading: false,
  titleBgColor: 'white',
  activeNavigationTab: 'home',
};

export default SimplePageLayout;